export default "__VITE_ASSET__a6beed1f__"